/**
 * AppointmentDetailsCard Component
 *
 * @component
 * @description
 * A reusable card component that displays key details of a guest/appointment.
 * - Renders the guest's basic profile (name, DOB, gender, contact, etc.).
 * - Highlights the card when `selected` is true.
 * - Sends the selected guest back to the parent via `onSelect`.
 *
 * @prop {Object} guest - The guest object containing appointment details.
 * @prop {boolean} selected - Whether the card is currently selected.
 * @prop {Function} onSelect - Callback triggered when the card is clicked.
 *                              Receives the `guest` object as an argument.
 *
 */

import React from 'react';
import { Card, Typography } from 'antd';
import { useTranslation } from 'soxo-bootstrap-core';
import './appointment-details-card.scss';
import moment from 'moment';

const { Text } = Typography;

const AppointmentDetailsCard = ({ guest, selected, onSelect }) => {
    const { t } = useTranslation();

    if (!guest || !guest.first_name) return null;

    return (
        <Card
            className={`appointment-card ${selected ? 'appointment-card--selected' : ''}`}
            onClick={() => onSelect(guest)} //  send selected guest back
            hoverable
        >
            <div className="appointment-card__header">
                {/* Avatar Circle */}
                <div className="appointment-card__avatar">{guest.first_name?.charAt(0).toUpperCase()}</div>

                {/* Details */}
                <div className="appointment-card__details">
                    <Text strong>{guest.first_name}</Text>

                    <Text type="secondary">
                        {t('dob')}: <Text strong>{guest?.dob ? moment(guest?.dob).format('DD-MM-YYYY') : null}</Text>
                    </Text>

                    <Text>
                        {t('gender')}: <Text strong>{guest.gender}</Text>
                    </Text>

                    <Text>
                        {t('email')}: <Text strong>{guest.email_address || guest.prereg_email || guest.email}</Text>
                    </Text>

                    <Text>
                        {t('contact')}: <Text strong>{guest.phone_number || guest.prereg_mobile1 || guest.mobile1}</Text>
                    </Text>

                    <Text type="secondary">
                        {t('OP Number')}: <Text strong>{guest.op_no || guest.prereg_opno || guest.op_number}</Text>
                    </Text>

                    <Text>
                        {t('address')}: <Text strong>{guest.address1}</Text>
                    </Text>
                </div>
            </div>
        </Card>
    );
};

export default AppointmentDetailsCard;
